import { render } from "./ModalGallery.vue?vue&type=template&id=8f52d6d8&scoped=true"
import script from "./ModalGallery.vue?vue&type=script&lang=js"
export * from "./ModalGallery.vue?vue&type=script&lang=js"

import "./ModalGallery.vue?vue&type=style&index=0&id=8f52d6d8&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f52d6d8"]])

export default __exports__